import { QuizMainOnboardingStep, QuizMainStep } from '@stores/quiz/enums'

export enum StepName {
  EducationLevel = 'education_level',
  Grade = 'grade',
  FocusIssues = 'focus_issues',
  DescribePerformance = 'describe_performance',
  PeersConcern = 'peers_concern',
  PriorExperience = 'prior_experience',
  ChildFeeling = 'child\'s_feeling',
  ChildGender = 'child\'s_gender',
  AdhdSymptoms = 'adhd_symptoms',
  TypeOfSchool = 'type_of_school',
  ChildDiscipline = 'child_discipline',
  Score = 'last_assessment',
  StudyGoal = 'study_goal',
  HowSoon = 'how_soon',
  HowSociable = 'how_sociable',
  HandleHomework = 'handle_homework',
  SummerLearning = 'summer_learning',
  SummerChallenges = 'summer_challenges',
  SummerLoss = 'summer_loss',
  EnjoyLearning = 'enjoy_learning',
  CovidImpact = 'COVID_impact',
  OutOfSchoolTutor = 'out_of_school_tutor',
  SeekMath = 'seek_math',
  TriedToHelp = 'tried_to_help',
  HomeworkDifficulties = 'homework_difficulties',
  WantEnjoy = 'want_enjoy',
  TeacherImpact = 'teacher_impact',
  TeacherSay = 'teacher_say',
  SchoolEfficiency = 'school_efficiency',
  ChildDistracted = 'child_distracted',
  LearningGeneral = 'learning_general',
  AdhdDiagnosis = 'adhd_diagnosis',
  SchoolStress = 'school_stress',
  AnxietyTriggers = 'anxiety_triggers',
  MisunderstoodTeachers = 'misunderstood_teachers',
  HomeworkStruggle = 'homework_struggle',
  ParentFeelings = 'parent_feelings',
  ChildEngaged = 'child_engaged',
  HandleFeedback = 'handle_feedback',
  DidYouHear = 'did_you_hear',
  EnglishLanguageArts = 'english_language_arts',
  AdhdMathConnection = 'adhd_math_connection',
  FocusAfterBreak = 'focus_after_break',
  FallAfterBreak = 'fall_after_break',
  BreaksAfterStress = 'breaks_after_stress',
  StressLowerPerformance = 'stress_lower_performance',
  ChildAge = 'child_age',
  TroubleOrganized = 'trouble_organized',
  TiredUnmotivated = 'tired_unmotivated',
  DrainedExhausted = 'drained_exhausted',
  Headaches = 'headaches',
  LowSelfEsteem = 'low_self-esteem',
  SadnessAnxiety = 'sadness_anxiety',
  SleepingIssues = 'sleeping_issues',
  StressAffect = 'stress_affect',
  WhatStresses = 'what_stresses',
  SymptomsAffect = 'symptoms_affect',
  LastFeel = 'last_feel',
  MathMostChallenging = 'math_most_challenging',
  WhyStrugglesMath = 'why_struggles_math',
  MathEffectStress = 'math_effect_stress',
  TeacherCauseIssues = 'teacher_cause_issues',
  PositiveHabits = 'positive_habits',
  QuiteHabits = 'quite_habits',
  HowMotivated = 'how_motivated',
  ImportantEvent = 'important_event',
  WhenEvent = 'when_event',
  HowMuchTime = 'how_much_time',
  Summary = 'summary',
  CurrentMathLevel = 'current_math_level',
  Personality = 'personality',
  LoseInterest = 'lose_interest',
  PlanKeySkills = 'plan_key_skills',
  HowMany = 'how_many',
  WantAddEla = 'want_add_ela',
}

export const answersNames: Partial<Record<QuizMainStep, string>> = {
  [QuizMainStep.EducationLevel]: 'answer_education_level',
  [QuizMainStep.Grade]: 'answer_grade',
  [QuizMainStep.FocusIssues]: 'answer_focus_issues',
  [QuizMainStep.DescribePerformance]: 'answer_describe_performance',
  [QuizMainStep.PeersConcern]: 'answer_peers_concern',
  [QuizMainStep.PriorExperience]: 'answer_prior_experience',
  [QuizMainStep.ChildFeeling]: 'answer_child\'s_feeling',
  [QuizMainStep.ChildGender]: 'answer_child\'s_gender',
  [QuizMainStep.AdhdSymptoms]: 'answer_adhd_symptoms',
  [QuizMainStep.TypeOfSchool]: 'answer_type_of_school',
  [QuizMainStep.ChildDiscipline]: 'answer_child_discipline',
  [QuizMainStep.Score]: 'answer_score',
  [QuizMainStep.StudyGoal]: 'answer_study_goal',
  [QuizMainStep.HowSoon]: 'answer_how_soon',
  [QuizMainStep.HowSociable]: 'answer_how_sociable',
  [QuizMainStep.HandleHomework]: 'answer_handle_homework',
  [QuizMainStep.SummerLearning]: 'answer_summer_learning',
  [QuizMainStep.SummerChallenges]: 'answer_summer_challenges',
  [QuizMainStep.SummerLoss]: 'answer_summer_loss',
  [QuizMainStep.EnjoyLearning]: 'answer_enjoy_learning',
  [QuizMainStep.CovidImpact]: 'answer_COVID_impact',
  [QuizMainStep.OutOfSchoolTutor]: 'answer_out_of_school_tutor',
  [QuizMainStep.SeekMath]: 'answer_seek_math',
  [QuizMainStep.TriedToHelp]: 'answer_tried_to_help',
  [QuizMainStep.HomeworkDifficulties]: 'answer_homework_difficulties',
  [QuizMainStep.WantEnjoy]: 'answer_want_enjoy',
  [QuizMainStep.TeacherImpact]: 'answer_teacher_impact',
  [QuizMainStep.TeacherSay]: 'answer_teacher_say',
  [QuizMainStep.SchoolEfficiency]: 'answer_school_efficiency',
  [QuizMainStep.ChildDistracted]: 'answer_child_distracted',
  [QuizMainStep.LearningGeneral]: 'answer_learning_general',
  [QuizMainStep.AdhdDiagnosis]: 'answer_adhd_diagnosis',
  [QuizMainStep.SchoolStress]: 'answer_school_stress',
  [QuizMainStep.AnxietyTriggers]: 'answer_anxiety_triggers',
  [QuizMainStep.MisunderstoodTeachers]: 'answer_misunderstood_teachers',
  [QuizMainStep.HomeworkStruggle]: 'answer_homework_struggle',
  [QuizMainStep.ParentFeelings]: 'answer_parent_feelings',
  [QuizMainStep.ChildEngaged]: 'answer_child_engaged',
  [QuizMainStep.HandleFeedback]: 'answer_handle_feedback',
  [QuizMainStep.DidYouHear]: 'answer_did_you_hear',
  [QuizMainStep.EnglishLanguageArts]: 'answer_english_language_arts',
  [QuizMainStep.AdhdMathConnection]: 'answer_adhd_math_connection',
  [QuizMainStep.FocusAfterBreak]: 'answer_focus_after_break',
  [QuizMainStep.FallAfterBreak]: 'answer_fall_after_break',
  [QuizMainStep.BreaksAfterStress]: 'answer_breaks_after_stress',
  [QuizMainStep.StressLowerPerformance]: 'answer_stress_lower_performance',
  [QuizMainStep.ChildAge]: 'answer_child_age',
  [QuizMainStep.TroubleOrganized]: 'answer_trouble_organized',
  [QuizMainStep.TiredUnmotivated]: 'answer_tired_unmotivated',
  [QuizMainStep.DrainedExhausted]: 'answer_drained_exhausted',
  [QuizMainStep.Headaches]: 'answer_headaches',
  [QuizMainStep.LowSelfEsteem]: 'answer_low_self-esteem',
  [QuizMainStep.SadnessAnxiety]: 'answer_sadness_anxiety',
  [QuizMainStep.SleepingIssues]: 'answer_sleeping_issues',
  [QuizMainStep.StressAffect]: 'answer_stress_affect',
  [QuizMainStep.WhatStresses]: 'answer_what_stresses',
  [QuizMainStep.SymptomsAffect]: 'answer_symptoms_affect',
  [QuizMainStep.LastFeel]: 'answer_last_feel',
  [QuizMainStep.MathMostChallenging]: 'answer_math_most_challenging',
  [QuizMainStep.WhyStrugglesMath]: 'answer_why_struggles_math',
  [QuizMainStep.MathEffectStress]: 'answer_math_effect_stress',
  [QuizMainStep.TeacherCauseIssues]: 'answer_teacher_cause_issues',
  [QuizMainStep.PositiveHabits]: 'answer_positive_habits',
  [QuizMainStep.QuiteHabits]: 'answer_quite_habits',
  [QuizMainStep.HowMotivated]: 'answer_how_motivated',
  [QuizMainStep.ImportantEvent]: 'answer_important_event',
  [QuizMainStep.WhenEvent]: 'answer_when_event',
  [QuizMainStep.HowMuchTime]: 'answer_how_much_time',
  [QuizMainStep.CurrentMathLevel]: 'answer_current_math_level',
  [QuizMainStep.Personality]: 'answer_personality',
  [QuizMainStep.LoseInterest]: 'answer_lose_interest',
  [QuizMainStep.PlanKeySkills]: 'answer_plan_key_skills',
  [QuizMainStep.HowMany]: 'answer_how_many',
  [QuizMainStep.WantAddEla]: 'answer_want_add_ela',
}

export const pageViewQuestionEventNames: Partial<Record<QuizMainStep, string>> = {
  [QuizMainStep.EducationLevel]: 'education_level',
  [QuizMainStep.Grade]: 'grade',
  [QuizMainStep.FocusIssues]: 'focus_issues',
  [QuizMainStep.DescribePerformance]: 'describe_performance',
  [QuizMainStep.PeersConcern]: 'peers_concern',
  [QuizMainStep.PriorExperience]: 'prior_experience',
  [QuizMainStep.ChildFeeling]: 'child\'s_feeling',
  [QuizMainStep.ChildGender]: 'child\'s_gender',
  [QuizMainStep.AdhdSymptoms]: 'adhd_symptoms',
  [QuizMainStep.TypeOfSchool]: 'type_of_school',
  [QuizMainStep.ChildDiscipline]: 'child_discipline',
  [QuizMainStep.Score]: 'last_assessment',
  [QuizMainStep.StudyGoal]: 'study_goal',
  [QuizMainStep.HowSoon]: 'how_soon',
  [QuizMainStep.HowSociable]: 'how_sociable',
  [QuizMainStep.HandleHomework]: 'handle_homework',
  [QuizMainStep.SummerLearning]: 'summer_learning',
  [QuizMainStep.Zip]: 'zip',
  [QuizMainStep.EnterEmail]: 'enter_email',
  [QuizMainStep.ParentName]: 'parent_name',
  [QuizMainStep.PhoneNumber]: 'phone_number',
  [QuizMainStep.SummerChallenges]: 'summer_challenges',
  [QuizMainStep.SummerLoss]: 'summer_loss',
  [QuizMainStep.EnjoyLearning]: 'enjoy_learning',
  [QuizMainStep.CovidImpact]: 'COVID_impact',
  [QuizMainStep.OutOfSchoolTutor]: 'out_of_school_tutor',
  [QuizMainStep.SeekMath]: 'seek_math',
  [QuizMainStep.TriedToHelp]: 'tried_to_help',
  [QuizMainStep.HomeworkDifficulties]: 'homework_difficulties',
  [QuizMainStep.WantEnjoy]: 'want_enjoy',
  [QuizMainStep.TeacherImpact]: 'teacher_impact',
  [QuizMainStep.TeacherSay]: 'teacher_say',
  [QuizMainStep.SchoolEfficiency]: 'school_efficiency',
  [QuizMainStep.ChildDistracted]: 'child_distracted',
  [QuizMainStep.LearningGeneral]: 'learning_general',
  [QuizMainStep.AdhdDiagnosis]: 'adhd_diagnosis',
  [QuizMainStep.SchoolStress]: 'school_stress',
  [QuizMainStep.AnxietyTriggers]: 'anxiety_triggers',
  [QuizMainStep.MisunderstoodTeachers]: 'misunderstood_teachers',
  [QuizMainStep.HomeworkStruggle]: 'homework_struggle',
  [QuizMainStep.ParentFeelings]: 'parent_feelings',
  [QuizMainStep.ChildEngaged]: 'child_engaged',
  [QuizMainStep.HandleFeedback]: 'handle_feedback',
  [QuizMainStep.DidYouHear]: 'did_you_hear',
  [QuizMainStep.EnglishLanguageArts]: 'english_language_arts',
  [QuizMainStep.AdhdMathConnection]: 'adhd_math_connection',
  [QuizMainStep.FocusAfterBreak]: 'focus_after_break',
  [QuizMainStep.FallAfterBreak]: 'fall_after_break',
  [QuizMainStep.BreaksAfterStress]: 'breaks_after_stress',
  [QuizMainStep.StressLowerPerformance]: 'stress_lower_performance',
  [QuizMainStep.ChildAge]: 'child_age',
  [QuizMainStep.TroubleOrganized]: 'trouble_organized',
  [QuizMainStep.TiredUnmotivated]: 'tired_unmotivated',
  [QuizMainStep.DrainedExhausted]: 'drained_exhausted',
  [QuizMainStep.Headaches]: 'headaches',
  [QuizMainStep.LowSelfEsteem]: 'low_self-esteem',
  [QuizMainStep.SadnessAnxiety]: 'sadness_anxiety',
  [QuizMainStep.SleepingIssues]: 'sleeping_issues',
  [QuizMainStep.StressAffect]: 'stress_affect',
  [QuizMainStep.WhatStresses]: 'what_stresses',
  [QuizMainStep.SymptomsAffect]: 'symptoms_affect',
  [QuizMainStep.LastFeel]: 'last_feel',
  [QuizMainStep.MathMostChallenging]: 'math_most_challenging',
  [QuizMainStep.WhyStrugglesMath]: 'why_struggles_math',
  [QuizMainStep.MathEffectStress]: 'math_effect_stress',
  [QuizMainStep.TeacherCauseIssues]: 'teacher_cause_issues',
  [QuizMainStep.PositiveHabits]: 'positive_habits',
  [QuizMainStep.QuiteHabits]: 'quite_habits',
  [QuizMainStep.HowMotivated]: 'how_motivated',
  [QuizMainStep.ImportantEvent]: 'important_event',
  [QuizMainStep.WhenEvent]: 'when_event',
  [QuizMainStep.HowMuchTime]: 'how_much_time',
  [QuizMainStep.CurrentMathLevel]: StepName.CurrentMathLevel,
  [QuizMainStep.Personality]: StepName.Personality,
  [QuizMainStep.LoseInterest]: StepName.LoseInterest,
  [QuizMainStep.PlanKeySkills]: StepName.PlanKeySkills,
  [QuizMainStep.HowMany]: StepName.HowMany,
  [QuizMainStep.WantAddEla]: StepName.WantAddEla,
}

export const sentAnswerEventNames: Partial<Record<QuizMainStep, string>> = {
  [QuizMainStep.EducationLevel]: StepName.EducationLevel,
  [QuizMainStep.Grade]: StepName.Grade,
  [QuizMainStep.FocusIssues]: StepName.FocusIssues,
  [QuizMainStep.DescribePerformance]: StepName.DescribePerformance,
  [QuizMainStep.PeersConcern]: StepName.PeersConcern,
  [QuizMainStep.PriorExperience]: StepName.PriorExperience,
  [QuizMainStep.ChildFeeling]: StepName.ChildFeeling,
  [QuizMainStep.ChildGender]: StepName.ChildGender,
  [QuizMainStep.AdhdSymptoms]: StepName.AdhdSymptoms,
  [QuizMainStep.TypeOfSchool]: StepName.TypeOfSchool,
  [QuizMainStep.ChildDiscipline]: StepName.ChildDiscipline,
  [QuizMainStep.Score]: StepName.Score,
  [QuizMainStep.StudyGoal]: StepName.StudyGoal,
  [QuizMainStep.HowSoon]: StepName.HowSoon,
  [QuizMainStep.HowSociable]: StepName.HowSociable,
  [QuizMainStep.HandleHomework]: StepName.HandleHomework,
  [QuizMainStep.SummerLearning]: StepName.SummerLearning,
  [QuizMainStep.SummerChallenges]: StepName.SummerChallenges,
  [QuizMainStep.SummerLoss]: StepName.SummerLoss,
  [QuizMainStep.EnjoyLearning]: StepName.EnjoyLearning,
  [QuizMainStep.CovidImpact]: StepName.CovidImpact,
  [QuizMainStep.OutOfSchoolTutor]: StepName.OutOfSchoolTutor,
  [QuizMainStep.SeekMath]: StepName.SeekMath,
  [QuizMainStep.TriedToHelp]: StepName.TriedToHelp,
  [QuizMainStep.HomeworkDifficulties]: StepName.HomeworkDifficulties,
  [QuizMainStep.WantEnjoy]: StepName.WantEnjoy,
  [QuizMainStep.TeacherImpact]: StepName.TeacherImpact,
  [QuizMainStep.TeacherSay]: StepName.TeacherSay,
  [QuizMainStep.SchoolEfficiency]: StepName.SchoolEfficiency,
  [QuizMainStep.ChildDistracted]: StepName.ChildDistracted,
  [QuizMainStep.LearningGeneral]: StepName.LearningGeneral,
  [QuizMainStep.AdhdDiagnosis]: StepName.AdhdDiagnosis,
  [QuizMainStep.SchoolStress]: StepName.SchoolStress,
  [QuizMainStep.AnxietyTriggers]: StepName.AnxietyTriggers,
  [QuizMainStep.MisunderstoodTeachers]: StepName.MisunderstoodTeachers,
  [QuizMainStep.HomeworkStruggle]: StepName.HomeworkStruggle,
  [QuizMainStep.ParentFeelings]: StepName.ParentFeelings,
  [QuizMainStep.ChildEngaged]: StepName.ChildEngaged,
  [QuizMainStep.HandleFeedback]: StepName.HandleFeedback,
  [QuizMainStep.DidYouHear]: StepName.DidYouHear,
  [QuizMainStep.EnglishLanguageArts]: StepName.EnglishLanguageArts,
  [QuizMainStep.AdhdMathConnection]: StepName.AdhdMathConnection,
  [QuizMainStep.FocusAfterBreak]: StepName.FocusAfterBreak,
  [QuizMainStep.FallAfterBreak]: StepName.FallAfterBreak,
  [QuizMainStep.BreaksAfterStress]: StepName.BreaksAfterStress,
  [QuizMainStep.StressLowerPerformance]: StepName.StressLowerPerformance,
  [QuizMainStep.ChildAge]: StepName.ChildAge,
  [QuizMainStep.TroubleOrganized]: StepName.TroubleOrganized,
  [QuizMainStep.TiredUnmotivated]: StepName.TiredUnmotivated,
  [QuizMainStep.DrainedExhausted]: StepName.DrainedExhausted,
  [QuizMainStep.Headaches]: StepName.Headaches,
  [QuizMainStep.LowSelfEsteem]: StepName.LowSelfEsteem,
  [QuizMainStep.SadnessAnxiety]: StepName.SadnessAnxiety,
  [QuizMainStep.SleepingIssues]: StepName.SleepingIssues,
  [QuizMainStep.StressAffect]: StepName.StressAffect,
  [QuizMainStep.WhatStresses]: StepName.WhatStresses,
  [QuizMainStep.SymptomsAffect]: StepName.SymptomsAffect,
  [QuizMainStep.LastFeel]: StepName.LastFeel,
  [QuizMainStep.MathMostChallenging]: StepName.MathMostChallenging,
  [QuizMainStep.WhyStrugglesMath]: StepName.WhyStrugglesMath,
  [QuizMainStep.MathEffectStress]: StepName.MathEffectStress,
  [QuizMainStep.TeacherCauseIssues]: StepName.TeacherCauseIssues,
  [QuizMainStep.PositiveHabits]: StepName.PositiveHabits,
  [QuizMainStep.QuiteHabits]: StepName.QuiteHabits,
  [QuizMainStep.HowMotivated]: StepName.HowMotivated,
  [QuizMainStep.ImportantEvent]: StepName.ImportantEvent,
  [QuizMainStep.WhenEvent]: StepName.WhenEvent,
  [QuizMainStep.HowMuchTime]: StepName.HowMuchTime,
  [QuizMainStep.CurrentMathLevel]: StepName.CurrentMathLevel,
  [QuizMainStep.Personality]: StepName.Personality,
  [QuizMainStep.LoseInterest]: StepName.LoseInterest,
  [QuizMainStep.PlanKeySkills]: StepName.PlanKeySkills,
  [QuizMainStep.HowMany]: StepName.HowMany,
  [QuizMainStep.WantAddEla]: StepName.WantAddEla,
}

export const pageViewPowerScreenEventNames: Partial<Record<QuizMainStep, string>> = {
  [QuizMainStep.ScreenAdhdLimit]: 'adhd_limit',
  [QuizMainStep.ScreenSummary]: 'summary',
  [QuizMainStep.ScreenMagicView]: 'magic_screen_view',
  [QuizMainStep.ScreenSummerLimit]: 'summer_limit',
  [QuizMainStep.ScreenLearningLimit]: 'learning_limit',
  [QuizMainStep.ScreenPracticeEffort]: 'practice_effort',
  [QuizMainStep.ScreenOnlyPlan]: 'only_plan',
  [QuizMainStep.ScreenProcessing]: 'processing',
  [QuizMainStep.ScreenSeeTheProgress]: 'see_the_progress',
  [QuizMainStep.ScreenRightTeacher]: 'right_teacher',
  [QuizMainStep.ScreenEBook]: 'e_book',
  [QuizMainStep.ScreenMathInMedia]: 'math_in_media',
  [QuizMainStep.ScreenParentsChooseUs]: 'parents_choose_us',
  [QuizMainStep.ScreenMathN1Subject]: 'math_n1_subject',
  [QuizMainStep.ScreenRegularPractice]: 'regular_practice',
  [QuizMainStep.ScreenBreakLimit]: 'break_limit',
  [QuizMainStep.ScreenHiddenCause]: 'hidden_cause',
  [QuizMainStep.ScreenScienceMoment]: 'science_moment',
  [QuizMainStep.ScreenExpertEducators]: 'expert_educators',
  [QuizMainStep.ScreenKidsJoined]: 'kids_joined',
}

export const pageViewOnboardingPowerScreenEventNames: Partial<Record<QuizMainOnboardingStep, string>> = {
  [QuizMainOnboardingStep.ScreenSuccessful]: 'successful_booking',
  [QuizMainOnboardingStep.ScreenTakeLaptop]: 'take_laptop',
  [QuizMainOnboardingStep.ScreenFindEmail]: 'find_email',
  [QuizMainOnboardingStep.ScreenLessonButton]: 'lesson_button',
  [QuizMainOnboardingStep.ScreenMeetTeacher]: 'meet_teacher',
  [QuizMainOnboardingStep.ScreenTopTutor]: 'top_tutor',
  [QuizMainOnboardingStep.ScreenSucceedMath]: 'succeed_in_math',
  [QuizMainOnboardingStep.ScreenAssessmentTest]: 'assessment_test',
  [QuizMainOnboardingStep.ScreenKnowledgeReport]: 'get_knowledge_report',
  [QuizMainOnboardingStep.ScreenJoinClass]: 'use_desktop',
  [QuizMainOnboardingStep.ScreenRecommended]: '95_of_users',
  [QuizMainOnboardingStep.ScreenGuaranteedGrowth]: 'guaranteed_growth',
  [QuizMainOnboardingStep.ScreenAssessmentProcessing]: 'assessment_processing',
  [QuizMainOnboardingStep.ScreenAssessmentCompleted]: 'assessment_completed',
  [QuizMainOnboardingStep.AssessmentFirst]: 'assessment_first',
  [QuizMainOnboardingStep.AssessmentSecond]: 'assessment_second',
  [QuizMainOnboardingStep.AssessmentThird]: 'assessment_third',
  [QuizMainOnboardingStep.AssessmentFourth]: 'assessment_fourth',
}
